import { render } from "./Submissions.vue?vue&type=template&id=88750b5c&scoped=true&ts=true"
import script from "./Submissions.vue?vue&type=script&lang=ts"
export * from "./Submissions.vue?vue&type=script&lang=ts"

import "./Submissions.vue?vue&type=style&index=0&id=88750b5c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88750b5c"]])

export default __exports__